import { render } from "./ag-create-ignore-event.vue?vue&type=template&id=1746ea2c&scoped=true"
import script from "./ag-create-ignore-event.vue?vue&type=script&lang=js"
export * from "./ag-create-ignore-event.vue?vue&type=script&lang=js"

import "./ag-create-ignore-event.vue?vue&type=style&index=0&id=1746ea2c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1746ea2c"]])

export default __exports__